import { minDate } from "../constants/validations";

export const parseDate = (dateString: string): Date | null => {
    const [day, month, year] = dateString.split("/").map((part) => parseInt(part, 10));
    if (!day || !month || !year) return null; 
    return new Date(year, month - 1, day);
  };

export const isDateEarlierThanToday = (dateString: string): boolean => {
  const [day, month, year] = dateString.split('/').map(Number); 
  const inputDate = new Date(year, month - 1, day);  
  const today = new Date();
  today.setHours(0, 0, 0, 0);   
  return inputDate <= today;
};

export const isDateEarlierThanSpecificDate = (dateString: string): boolean => {
  const [day, month, year] = dateString.split('/').map(Number); 
  const inputDate = new Date(year, month - 1, day);  
  const [oldDay, oldMonth, oldYear] = minDate.split('/').map(Number); 
  const oldDate = new Date(oldYear, oldMonth - 1, oldDay);  
  return inputDate < oldDate;
};

export const isDateLaterThanToday = (dateString: string): boolean => {
  const [day, month, year] = dateString.split('/').map(Number); 
  const inputDate = new Date(year, month - 1, day);  
  const today = new Date();
  today.setHours(0, 0, 0, 0);   
  return inputDate > today;
};

export const isDateTodayOrInFuture = (dateString: string): boolean => {
  const [day, month, year] = dateString.split('/').map(Number); 
  const inputDate = new Date(year, month - 1, day);  
  const today = new Date();
  today.setHours(0, 0, 0, 0);   
  return inputDate >= today;
};